export enum REST_REQUEST_RESULT {
    'SUCCESSFUL' = 'SUCCESSFUL',
    'FAILED' = 'FAILED'
}
